import React from 'react';
import AuthForm from '../components/AuthForm';

const LoginPage = () => {
  return <AuthForm initialMode="login" />;
};

export default LoginPage; 